// js
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HotKeys } from 'react-hotkeys';
import Button from '../common/Button';
import SourcesHeaderStats from './SourcesHeaderStats';
import SourcesHeaderNav from './SourcesHeaderNav';
import PeakBufferInput from './PeakBufferInput';
import DefaultLogSizeSelector from '../../containers/sources/DefaultLogSizeSelector';
import ImportSourcesButton from '../../containers/sources/ImportSourcesButton';
import { debounce } from 'lodash';
import { updatePeakBuffer } from '../../actions/dsaActions';
import { makeGetAreaSourcesStats, makeGetAreaSourcesCompletionProgress } from '../../selectors/dsa/sourcesSelectors';
import { SectionHeader } from '@its-svp/svp-common-ui';


class SourcesHeader extends Component {
  constructor(props) {
    super(props);
    const dsa = props.dsa;

    this.state = {
      peakBuffer: dsa.dsa.peak_buffer > 0 && + Math.round(dsa.dsa.peak_buffer * 100) || 0,
      defaultLogSizeSelectorVisible: false
    };

    this.savePeakBuffer = debounce(this.savePeakBuffer, 2000);
    this.toggleDefaultLogSizeSelector = this.toggleDefaultLogSizeSelector.bind(this);
  }

  changePeakBuffer (event) {
    this.setState({peakBuffer: event.target.value});
    this.savePeakBuffer(event.target.value);
  }

  savePeakBuffer (peakBuffer) {
    this.props.updatePeakBuffer(this.props.dsa.dsa.id, Math.round(peakBuffer) / 100);
  }

  toggleDefaultLogSizeSelector() {
    this.setState({ defaultLogSizeSelectorVisible: !this.state.defaultLogSizeSelectorVisible });
  }

  render() {
    let { area, areas, activeAreaIds, stats, canViewTotalIndexed, baseNavRoute } = this.props;
    const { defaultLogSizeSelectorVisible } = this.state;
    let logSizeSelector = null;

    if (defaultLogSizeSelectorVisible) {
      logSizeSelector = (<DefaultLogSizeSelector />);
    }

    return (
      <HotKeys
        keyMap={{'toggleDefaultLogSizeSelector': 'ctrl+shift+d'}}
        handlers={{'toggleDefaultLogSizeSelector': this.toggleDefaultLogSizeSelector}}
        focused
        attach={window}
        style={{outline: 0}}
      >
        <div className='sources-header svp-common-ui'>
          {!this.props.area &&
            <SectionHeader
              title='Sources'
              description='Work with the relevant customer teams to identify information related to data sources needed to achieve key goals. Add items as needed to accurately represent the customer&apos;s environment.'
              landing
            >
              <PeakBufferInput
                value={this.state.peakBuffer}
                onChange={this.changePeakBuffer.bind(this)} // eslint-disable-line react/jsx-no-bind
                disabled={!this.props.abilities.canEditPeakBuffer}
              />
              {logSizeSelector}
              <div className='sect21ion-header-buttons'>
                <ImportSourcesButton />
                <Button
                  to={`${baseNavRoute}/sources/${this.props.activeAreaIds[0] || ''}`}
                  primary
                  disabled={this.props.activeAreaIds.length === 0}
                  label='Start'
                />
              </div>
            </SectionHeader>
          }
          {!!this.props.area &&
            <div className='header-wrapper'>
              <SourcesHeaderNav
                area={area}
                areas={areas}
                dsa={this.props.dsa}
                activeAreaIds={activeAreaIds}
                baseNavRoute={baseNavRoute}
              />
              <SectionHeader
                title={`Sources: ${this.props.area.title}`}
                caseCount={`${this.props.progress.current}/${this.props.progress.total} Sections Complete`}
              />
            </div>
          }
          {!!this.props.area &&
            <SourcesHeaderStats
              configuredItemsCount={stats.configuredItems}
              dataIndexed={stats.dataIndexed}
              dataRequired={stats.dataRequired}
              percentIndexed={stats.percentIndexed}
              isPercentage={canViewTotalIndexed}
              ciscoDataPerDay={stats.ciscoDataPerDay}
              nonCiscoDataPerDay={stats.nonCiscoDataPerDay}
              ciscoDataIndexed={stats.ciscoDataIndexed}
              nonCiscoDataIndexed={stats.nonCiscoDataIndexed}
            />
          }
        </div>
      </HotKeys>
    );
  }
}

const mapStateToProps = (state, props) => {
  const getAreaSourcesCompletionProgress = makeGetAreaSourcesCompletionProgress();
  const getAreaSourcesStats = makeGetAreaSourcesStats();

  return {
    stats: getAreaSourcesStats(state, props),
    progress: getAreaSourcesCompletionProgress(state, props)
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updatePeakBuffer: (dsaId, peakBuffer) => dispatch(updatePeakBuffer(dsaId, peakBuffer))
  };
};

SourcesHeader.propTypes = {
  area: PropTypes.object,
  areas: PropTypes.array,
  activeAreaIds: PropTypes.array,
  baseNavRoute: PropTypes.string.isRequired,
  dsa: PropTypes.object,
  progress: PropTypes.object,
  stats: PropTypes.object,
  updatePeakBuffer: PropTypes.func,
  canViewTotalIndexed: PropTypes.bool,
  abilities: PropTypes.object
};

export default connect(mapStateToProps, mapDispatchToProps)(SourcesHeader);



// WEBPACK FOOTER //
// ./src/components/sources/SourcesHeader.js